import { Outlet, createFileRoute } from '@tanstack/react-router'
import { Header } from '@/components/Header'
import { Footer } from '@/components/Footer'

export const Route = createFileRoute('/blogs')({
  component: BlogLayout,
})

function BlogLayout() {
  return (
    <div className="relative min-h-screen flex flex-col overflow-x-clip bg-[var(--color-bg-primary)]">
      <Header />
      {/* One overhead light, same as the PageHero on other public pages. */}
      <div
        aria-hidden
        className="pointer-events-none absolute -top-[30rem] left-1/2 h-[46rem] w-[72rem] -translate-x-1/2 rounded-full bg-[radial-gradient(closest-side,color-mix(in_srgb,var(--color-primary)_16%,transparent),transparent)]"
      />
      <main className="relative z-10 mx-auto w-full max-w-7xl flex-1 px-6 pt-28 pb-20">
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}
